module.exports = __webpack_public_path__ + "img/header-weddingRingsMokumeGane.9e398be.jpg";